export default [{
  path: '/',
  component: () => import('./BoardList'),
  name: 'viewboard',
  meta: {
    resource: 'boards',
    actions: ['read']
  }
}]
